window.onload = function () {
  // banner elements
  var bannerElements = document.querySelectorAll('[id^="banner"]');
  var monthlyBannerElements = document.querySelectorAll(
    '[id^="monthlybanner"]'
  );

  bannerElements.forEach(function (banner) {
    var startDate = new Date(banner.dataset.startDate);
    var endDate = new Date(banner.dataset.endDate);
    var now = new Date();

    if (now >= startDate && now <= endDate) {
      banner.style.display = "block";
    } else {
      banner.style.display = "none";
    }
  });

  monthlyBannerElements.forEach(function (monthlybanner) {
    var displayDay = parseInt(monthlybanner.dataset.displayDay, 10);
    var now = new Date();

    if (now.getDate() === displayDay) {
      monthlybanner.style.display = "block";
    } else {
      monthlybanner.style.display = "none";
    }
  });

  // header banner elements
  var headerbannerElements = document.querySelectorAll('[id^="headerbanner"]');
  var headermonthlyBannerElements = document.querySelectorAll(
    '[id^="headermonthlybanner"]'
  );
  var defaultBanner = document.querySelector("#defaultBanner");
  var displayDefault = true;

  headerbannerElements.forEach(function (headerbanner) {
    var startDate = new Date(headerbanner.dataset.startDate);
    var endDate = new Date(headerbanner.dataset.endDate);
    var now = new Date();

    if (
      now.setHours(0, 0, 0, 0) >= startDate.setHours(0, 0, 0, 0) &&
      now.setHours(0, 0, 0, 0) <= endDate.setHours(0, 0, 0, 0)
    ) {
      headerbanner.style.display = "block";
      displayDefault = false;
    } else {
      headerbanner.style.display = "none";
    }
  });

  if (displayDefault) {
    headermonthlyBannerElements.forEach(function (headermonthlybanner) {
      var displayDay = parseInt(headermonthlybanner.dataset.displayDay, 10);
      var now = new Date();
      if (now.getDate() === displayDay) {
        headermonthlybanner.style.display = "block";
        displayDefault = false;
      } else {
        headermonthlybanner.style.display = "none";
      }
    });
  }

  if (displayDefault && defaultBanner != null) {
    defaultBanner.style.display = "block";
  }
};
